import React from "react";
import ContactForm from "./ContactForm";

export default class Contact extends React.Component {

    render(){
        return(
            <div className="contact-container">
                <h1>Contact Us</h1>
                <ContactForm />
            </div>
        )
    }
}